const getDefaultState = () => {
  return {
    tableHeaders: [
      { text: "No", align: "start", sortable: false, value: "no" },
      { text: "Name", align: "start", sortable: false, value: "name" },
      {
        text: "Description",
        align: "start",
        sortable: false,
        value: "description"
      },
      { text: "URL", align: "start", sortable: false, value: "url" },
      { text: "Icon", align: "start", sortable: false, value: "icon" },
      {
        text: "Activated",
        align: "start",
        sortable: false,
        value: "activated"
      },
      {
        text: "Action",
        align: "center",
        sortable: false,
        value: "action"
      }
    ]
  };
};

const state = getDefaultState();
export default {
  namespaced: true,
  name: "table",
  state
};
